import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBwdyQB9m75kFneO7FrYhJQKfyoqAlQU04",
    authDomain: "kexjobbsimonerik.firebaseapp.com",
    databaseURL: "https://kexjobbsimonerik-default-rtdb.europe-west1.firebasedatabase.app/",
    projectId: "kexjobbsimonerik",
    storageBucket: "kexjobbsimonerik.appspot.com",
    messagingSenderId: "632792666648",
    appId: "1:632792666648:web:212d73eb249f5f10a2296d",
    measurementId: "G-VB4ZJ0BJEE"
  };

firebase.initializeApp(firebaseConfig);

const database = firebase.database();
export {database};

